// extracted by mini-css-extract-plugin
export default {"switch":"Pf4Xk9jfi4H7rpuD2RES","on":"SJAvh02zm4ICoCZ3F404","off":"GxCivAttjCFtFVm68ajG","toggle":"A1Ouc4mcj5jPtVAdZ8oS"};